import useBreadcrumb from '../../Hooks/useBreadcrumb';
import './TermsOfUsePage.css';

export default function TermsOfUsePage () {
    const BreadCrumb = useBreadcrumb('Terms of Use');
    return (
        <div style={{ minHeight: '100vh' }}>
            {BreadCrumb}

            <section className='inner-page'>
                <div className='container'>
                    <div className='terms-of-use-content'>
                        <h1>Terms of Use</h1>
                        <p className='last-updated'>Last updated: {new Date().toLocaleDateString()}</p>

                        <section>
                            <h2>1. Acceptance of Terms</h2>
                            <p>
                                By accessing and using HydroMastery, you accept and agree to be bound by the terms and
                                provision of this agreement. If you do not agree to abide by the above, please do not
                                use this service.
                            </p>
                        </section>

                        <section>
                            <h2>2. Description of Service</h2>
                            <p>
                                HydroMastery is a web application designed for swimming performance tracking, coaching,
                                and analytics. The service allows athletes to track their workouts, tests, and race
                                results, and enables coaches to manage athletes, create training programs, and analyze
                                performance data.
                            </p>
                        </section>

                        <section>
                            <h2>2.1 Service Fees and Pricing</h2>
                            <p>
                                HydroMastery is currently provided free of charge. However, we reserve the right to
                                introduce fees, subscriptions, or other charges for the use of the service or certain
                                features in the future.
                            </p>
                            <p>
                                If we decide to implement fees or paid features, we will:
                            </p>
                            <ul>
                                <li>Provide at least 30 days' advance notice via email and/or prominent notice on our website</li>
                                <li>Clearly communicate the pricing structure, billing terms, and payment methods</li>
                                <li>Allow you to continue using free features (if available) or cancel your account before fees take effect</li>
                                <li>Honor any existing commitments or agreements made during the free period</li>
                            </ul>
                            <p>
                                Any fees, subscriptions, or charges will be clearly disclosed before you are charged.
                                You will have the opportunity to review and accept new pricing terms before any charges
                                are applied to your account. By continuing to use the service after fees are implemented,
                                you agree to the new pricing terms.
                            </p>
                            <p>
                                We may offer different service tiers, features, or subscription plans with varying
                                pricing. Details of any paid plans will be available on our website and in your account
                                settings.
                            </p>
                        </section>

                        <section>
                            <h2>3. User Accounts</h2>
                            <h3>3.1 Account Creation</h3>
                            <p>To use certain features of our service, you must register for an account. You agree to:</p>
                            <ul>
                                <li>Provide accurate, current, and complete information during registration</li>
                                <li>Maintain and update your account information to keep it accurate</li>
                                <li>Maintain the security of your password and account</li>
                                <li>Accept responsibility for all activities that occur under your account</li>
                            </ul>

                            <h3>3.2 Account Types</h3>
                            <p>
                                HydroMastery offers different account types (Athlete, Coach, Admin) with varying levels
                                of access and functionality. You agree to use the service in accordance with your
                                designated account type.
                            </p>
                        </section>

                        <section>
                            <h2>4. Acceptable Use</h2>
                            <p>You agree not to:</p>
                            <ul>
                                <li>Use the service for any illegal purpose or in violation of any laws</li>
                                <li>Violate or infringe upon the rights of others</li>
                                <li>Transmit any harmful code, viruses, or malicious software</li>
                                <li>Attempt to gain unauthorized access to the service or other users' accounts</li>
                                <li>Interfere with or disrupt the service or servers</li>
                                <li>Use automated systems to access the service without permission</li>
                                <li>Impersonate any person or entity</li>
                                <li>Harass, abuse, or harm other users</li>
                                <li>Send spam, unsolicited bulk emails, or any form of unsolicited commercial communications</li>
                                <li>Use the service to send emails that violate CAN-SPAM Act, GDPR, or other applicable email regulations</li>
                                <li>Collect email addresses or other personal information from other users without their consent</li>
                                <li>Use the service in any way that could damage, disable, or impair our email sending reputation</li>
                            </ul>
                        </section>

                        <section>
                            <h2>4.1 Email and Communication Policies</h2>
                            <p>
                                When using our email communication features, you agree to comply with all applicable laws
                                and regulations, including:
                            </p>
                            <ul>
                                <li>
                                    <strong>CAN-SPAM Act (US):</strong> You will not send unsolicited commercial emails,
                                    and all marketing emails will include accurate sender information and opt-out mechanisms.
                                </li>
                                <li>
                                    <strong>GDPR (EU):</strong> You will only send emails to recipients who have provided
                                    explicit consent, and you will honor opt-out requests promptly.
                                </li>
                                <li>
                                    <strong>Anti-Spam Policies:</strong> You will not use our service to send spam,
                                    phishing emails, or any form of malicious or fraudulent communications.
                                </li>
                                <li>
                                    <strong>List Hygiene:</strong> You will maintain accurate email lists and remove
                                    invalid, bounced, or unsubscribed email addresses promptly.
                                </li>
                            </ul>
                            <p>
                                Violation of these email policies may result in immediate suspension or termination of
                                your account and may subject you to legal action.
                            </p>
                        </section>

                        <section>
                            <h2>5. User Content</h2>
                            <p>
                                You retain ownership of any content you submit, post, or display on or through the
                                service. By submitting content, you grant us a worldwide, non-exclusive, royalty-free
                                license to use, reproduce, modify, and distribute your content for the purpose of
                                operating and providing the service.
                            </p>
                            <p>You are solely responsible for your content and agree that your content:</p>
                            <ul>
                                <li>Does not violate any third-party rights</li>
                                <li>Is accurate and not misleading</li>
                                <li>Does not contain offensive, harmful, or inappropriate material</li>
                            </ul>
                        </section>

                        <section>
                            <h2>6. Intellectual Property</h2>
                            <p>
                                The service and its original content, features, and functionality are owned by
                                HydroMastery and are protected by international copyright, trademark, patent, trade
                                secret, and other intellectual property laws.
                            </p>
                        </section>

                        <section>
                            <h2>7. Privacy and Data Protection</h2>
                            <p>
                                Your use of the service is also governed by our Privacy Policy. Please review our
                                Privacy Policy to understand our practices regarding the collection and use of your
                                information.
                            </p>
                            <p>
                                We are committed to protecting your privacy and complying with applicable data protection
                                laws, including GDPR, CCPA, and other regional regulations. By using our service, you
                                acknowledge that:
                            </p>
                            <ul>
                                <li>We process your personal data in accordance with our Privacy Policy</li>
                                <li>You have rights regarding your personal data as outlined in our Privacy Policy</li>
                                <li>We use industry-standard security measures to protect your data</li>
                                <li>We may use third-party service providers (such as AWS) that process data on our behalf</li>
                                <li>Your data may be transferred to and processed in countries other than your country of residence</li>
                            </ul>
                        </section>

                        <section>
                            <h2>8. Service Availability and Third-Party Services</h2>
                            <p>
                                We strive to provide a reliable service but do not guarantee that the service will be
                                available at all times. We reserve the right to modify, suspend, or discontinue the
                                service (or any part thereof) at any time with or without notice.
                            </p>
                            <h3>8.1 Third-Party Services</h3>
                            <p>
                                Our service relies on third-party services and infrastructure, including:
                            </p>
                            <ul>
                                <li>
                                    <strong>Amazon Web Services (AWS):</strong> We use AWS for cloud hosting, database
                                    services (MongoDB Atlas), and email services (SES). AWS services are subject to
                                    their own terms of service and privacy policies.
                                </li>
                                <li>
                                    <strong>Email Delivery:</strong> We use AWS Simple Email Service (SES) for email
                                    delivery. Email delivery is subject to AWS SES terms and policies, including bounce
                                    and complaint rate limits.
                                </li>
                            </ul>
                            <p>
                                We are not responsible for the availability, performance, or actions of third-party services.
                                However, we select service providers that meet high standards for security, reliability,
                                and compliance.
                            </p>
                        </section>

                        <section>
                            <h2>9. Disclaimer of Warranties</h2>
                            <p>
                                THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND,
                                EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF
                                MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
                            </p>
                        </section>

                        <section>
                            <h2>10. Limitation of Liability</h2>
                            <p>
                                TO THE MAXIMUM EXTENT PERMITTED BY LAW, HYDROMASTERY SHALL NOT BE LIABLE FOR ANY
                                INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF
                                PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE,
                                GOODWILL, OR OTHER INTANGIBLE LOSSES.
                            </p>
                        </section>

                        <section>
                            <h2>11. Termination</h2>
                            <p>
                                We may terminate or suspend your account and access to the service immediately, without
                                prior notice, for conduct that we believe violates these Terms of Use or is harmful to
                                other users, us, or third parties, including but not limited to:
                            </p>
                            <ul>
                                <li>Violation of email policies or sending spam</li>
                                <li>High bounce rates or complaint rates that threaten our email sending reputation</li>
                                <li>Fraudulent or illegal activity</li>
                                <li>Violation of intellectual property rights</li>
                                <li>Harassment or abuse of other users</li>
                                <li>Any activity that could result in suspension of our AWS SES account</li>
                            </ul>
                            <p>
                                Upon termination, your right to use the service will immediately cease. We may delete
                                or retain your account data in accordance with our Privacy Policy and applicable law.
                            </p>
                            <p>
                                You may terminate your account at any time by contacting us at{' '}
                                <a href='mailto:hydromastery@gmail.com'>hydromastery@gmail.com</a>. Upon termination,
                                we will delete or anonymize your personal data within 30 days, except where retention
                                is required by law.
                            </p>
                        </section>

                        <section>
                            <h2>12. Changes to Terms</h2>
                            <p>
                                We reserve the right to modify these Terms of Use at any time. We will notify users of
                                any material changes by:
                            </p>
                            <ul>
                                <li>Posting the new Terms of Use on this page</li>
                                <li>Updating the "Last updated" date</li>
                                <li>Sending an email notification for significant changes (where required by law)</li>
                                <li>Displaying a prominent notice on our website</li>
                            </ul>
                            <p>
                                Your continued use of the service after such changes constitutes acceptance of the new terms.
                                If you do not agree to the modified terms, you must stop using the service and may terminate
                                your account.
                            </p>
                        </section>

                        <section>
                            <h2>13. Governing Law and Dispute Resolution</h2>
                            <p>
                                These Terms of Use shall be governed by and construed in accordance with the laws of
                                Greece and Scotland, without regard to their conflict of law provisions.
                            </p>
                            <p>
                                For users in the European Union, these terms are subject to EU consumer protection laws
                                and regulations. If you are a consumer in the EU, you may have additional rights under
                                your local consumer protection laws.
                            </p>
                            <p>
                                Any disputes arising from these terms or your use of the service will be resolved through
                                good faith negotiation. If a dispute cannot be resolved, it will be subject to the
                                exclusive jurisdiction of the courts in Greece or Scotland, as applicable.
                            </p>
                        </section>

                        <section>
                            <h2>13.1 Compliance with Laws</h2>
                            <p>
                                You agree to comply with all applicable local, state, national, and international laws and
                                regulations when using our service, including but not limited to:
                            </p>
                            <ul>
                                <li>Data protection and privacy laws (GDPR, CCPA, etc.)</li>
                                <li>Email marketing regulations (CAN-SPAM Act, ePrivacy Directive, etc.)</li>
                                <li>Intellectual property laws</li>
                                <li>Export control laws</li>
                                <li>Anti-spam and anti-fraud laws</li>
                            </ul>
                            <p>
                                You are solely responsible for ensuring that your use of the service complies with all
                                applicable laws in your jurisdiction.
                            </p>
                        </section>

                        <section>
                            <h2>14. Contact Information and Support</h2>
                            <p>
                                If you have any questions, concerns, or need support regarding these Terms of Use, please
                                contact us:
                            </p>
                            <p>
                                <strong>Email:</strong> <a href='mailto:hydromastery@gmail.com'>hydromastery@gmail.com</a>
                                <br />
                                <strong>Subject Line:</strong> "Terms of Use Inquiry" or "Support Request"
                            </p>
                            <p>
                                We are committed to responding to your inquiries promptly. For urgent matters or security
                                concerns, please include "URGENT" in your subject line.
                            </p>
                            <p>
                                For complaints about email communications or to report spam, please contact us immediately
                                with details of the issue. We take all complaints seriously and will investigate promptly.
                            </p>
                        </section>

                        <section>
                            <h2>15. Severability and Entire Agreement</h2>
                            <p>
                                If any provision of these Terms of Use is found to be unenforceable or invalid, that
                                provision will be limited or eliminated to the minimum extent necessary, and the remaining
                                provisions will remain in full force and effect.
                            </p>
                            <p>
                                These Terms of Use, together with our Privacy Policy, constitute the entire agreement
                                between you and HydroMastery regarding the use of the service and supersede all prior
                                agreements and understandings.
                            </p>
                        </section>
                    </div>
                </div>
            </section>
        </div>
    );
}

